<template>
  <v-container fluid>
    <PartnerCardsTable
      class="pb-4"
    >
      <template v-slot:actions="{ dataset }">
        <avs-createButton
          :data="dataset"
          :name="$t('Nouveau Partenaire')"
          :spantext="
            $t('Nouveau Partenaire')
          "
          @click="handleNewPartnerCard()"
        >
        </avs-createButton>
        <avs-confirmDialog
          v-model="confirmDialogIsOpen"
          @cancel="handleCancel"
          @confirm="handleConfirm"
        />
      </template>
    </PartnerCardsTable>
  </v-container>
</template>
<script>
import PartnerCardsTable from "@/components/ri3/partnerCard/PartnerCardsTable.vue"
import PartnerCardService from "@/services/PartnerCardService"

export default {
  name: "PartnerCardsView",
  components: { PartnerCardsTable },
  data() {
    return {
      loading: false,
      confirmDialogIsOpen: false
    }
  },
  methods: {
    handleNewPartnerCard() {
      this.$router.push({
        name: "PartnerCardCreateUpdate"
      })
    },
    handleOpenValidateDialog() {
      this.confirmDialogIsOpen = true
    },
    handleCancel() {
      this.confirmDialogIsOpen = false
    },
    handleConfirm() {
      PartnerCardService.validate(this)
        .then(r => {
          this.$store.commit("app/updateProjectValidation", { validated_pcq_dsi: true })
          this.$store.commit("app/message", {
            msg: this.$t("messages.success.validate", {
              entity: this.$tc("categories.pcqdsi.name", 1)
            }),
            color: "success"
          })
          this.confirmDialogIsOpen = false
        })
        .catch(err => {
          if (err.response && err.response.status === 403) {
            // alert("Access denied: You do not have permission to access this resource.")
            this.$store.commit("app/message", {
              msg: this.$t("messages.error.permission_denied"),
              color: "error"
            })
          }
        })
      this.deleteDialogIsOpen = false
    },
  }
}
</script>
